/*global window,console*/
/*eslint no-console:0*/
define('app/models/Benchmark',['require','./AnalyticsEntity','config','glu/http','glu/$'],function(require) {
	'use strict';

	var AnalyticsEntity = require('./AnalyticsEntity'),
		config = require('config'),
		http = require('glu/http'),
		$ = require('glu/$');

	return AnalyticsEntity.extend({

		http: http,

		url: function() {
			return config.apiRoot + 'service/benchmarks/' + this.id;
		},

		getBenchmarkData: function() {
			return this.get('benchmark');
		},

		run: function() {
			var self = this;
			this.trigger('run');

			var requestData = this.getBenchmarkData();
			requestData.dashboardId = undefined;
			requestData.timeframe = this.get('timeframe');
			requestData.tenantCategory = this.get('tenantCategory');
			requestData.tenantRegion = this.get('tenantRegion');
			requestData.tenantState = this.get('tenantState');
			if (this.get('assetSizeLow')) {
				requestData.assetSizeLow = this.get('assetSizeLow');
			}
			if (this.get('assetSizeHigh')) {
				requestData.assetSizeHigh = this.get('assetSizeHigh');
			}

			return $.ajax(config.apiRoot + 'service/runbenchmark', {
				type: 'POST',
				contentType: 'application/json',
				data: JSON.stringify(requestData)
			}).then(function(res) {
				self.set('results', res.data, {
					silent: true
				});

				self.trigger('dataReceived');
			});
		},

		initialize: function(data) {
			this.setValues(data);
		},

		hasData: function() {
			return !!this.get('results');
		},

		setValues: function(data) {
			this.set('aggregation', data.aggregation);
			this.set('benchmark', data.benchmark);
			this.set('benchmarks', data.benchmarks);
			this.set('description', data.description);
			this.set('id', data.id);
			this.set('name', data.name);
			this.set('visual', data.visual);
		},

		canBeDeleted: function() {
			return true;
		},

		getName: function() {
			return this.get('benchmark').name;
		},

		getDescription: function() {
			return this.get('benchmark').description;
		},

		getBenchmarkFICount: function() {
			return this.get('results').rows[1] ? this.get('results').rows[1][2] : -1;
		}
	});
});

